import React from 'react';

import { NewsBlock } from '../../NewsBlock';
import { withListContainer, ListContainerProps } from '../hoc/withListContainer';

import { ListContainer } from './List';

const MainListContainer: React.FC<ListContainerProps> = (props) => {
  return <ListContainer {...props} heading={<NewsBlock className="h-mb-24" />} />;
};

export const MainList = withListContainer()(MainListContainer);
